import axios from 'axios';

export default {
  getTestersPhones({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/testersPhones/get`,
        params: ctx,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('insertTestersPhones', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  removeTestersPhones({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      commit('removeTestersPhonesRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/testersPhones/remove`,
        params: { id: id },
        method: 'DELETE'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('removeTestersPhonesRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('removeTestersPhonesRequestError', err);
          reject(err);
        });
    });
  },
  addTestersPhones({ commit, state }, { testersPhones, event }) {
    return new Promise((resolve, reject) => {
      commit('addTestersPhonesRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/testersPhones/add`,
        data: testersPhones,
        method: 'POST'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('addTestersPhonesRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('addTestersPhonesRequestError', err);
          reject(err);
        });
    });
  },
  editTestersPhones({ commit, state }, { testersPhones, event }) {
    return new Promise((resolve, reject) => {
      commit('editTesterEmailRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/testersPhones/edit`,
        data: testersPhones,
        method: 'POST'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('editTestersPhonesRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('editTestersPhonesRequestError', err);
          reject(err);
        });
    });
  }
};
